<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title">
          <a-icon class="margin-right" type="file-search" />Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker
                    placeholder="Select Date"
                    v-model="searchDate"
                    format="DD-MMM-YYYY"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: PO ... "
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                  <a-select-option value="po">PO</a-select-option>
                  <a-select-option value="wo">WO</a-select-option>
                    <!-- <a-select-option
                      v-for="item in getCategoryPI"
                      :key="item.value"
                      :value="item.value"
                      >{{ item.text }}</a-select-option
                    > -->
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="matauang">Currency</label>
                  <a-select
                    placeholder="Ex: IDR ..."
                    v-model="matauang"
                    class="width-full"
                    initialValue
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getAllMataUang"
                      :key="item.code"
                      :value="item.code"
                      >{{ item.code }} - {{ item.currency }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Adendum PO WO List"
        :isMonitoring="true"
        :manifestLink="getManifestLink"
        :dataList="searching"
        :estimasi="false"
        createLink="createAddendum"
        :disabledCreateEditLink="false"
        :sisaSaldo="false"
        :informasi="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "ListAddendum",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      kategori: undefined,
      searchDate: [],
      search: "",
      status: undefined,
      matauang: undefined,
      modalInfo: false,
      pageId: "",
    };
  },
  async mounted() {
    await this.fetchData();
    this.$store.dispatch("FETCH_ALL_MATA_UANG");
    Event.$on("handleInfo", this.infoToggle);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getCategoryPI",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getNavigation",
      "getNavigationId",
      "getAllMataUang",
    ]),
    searching() {
      var self = this;
      let outputData = this.dataList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            (obj.search &&
              obj.search.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
            (obj.sisa_saldo &&
              this.formatCurrency(obj.mata_uang, obj.sisa_saldo)
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      }
      
      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);

        outputData = outputData.filter(
          (obj) =>
            obj.create_dt &&
            moment(obj.create_dt).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.create_dt).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.kategori) {
        outputData = _.filter(outputData, (item) => {
          return item.transaction === self.kategori;
        });
      }

      if (this.matauang) {
        outputData = _.filter(outputData, (item) => {
          return item.mata_uang === self.matauang;
        });
      }

      if (this.status) {
        if (this.status=="closed"){
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.closeStatus && obj.closeStatus.toLowerCase().indexOf("close") >= 0
          );
        }else if(this.status=="cancelled"){
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.cancelStatus && obj.cancelStatus.toLowerCase().indexOf("canceled") >= 0
          );
        }else{
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.timeline[0].status && obj.timeline[0].status.toLowerCase().indexOf(self.status) >= 0 
          );
        }
      }

      return outputData;
    },
    getManifestLink() {
      return "AddendumManifest";
    },
  },
  methods: {
    moment,
    async fetchData() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "addendum",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            this.dataList.push({
              title: data.no_adendum,
              search:
                data.no_adendum +
                " " +
                data.adendum_nm +
                " " +
                data.create_dt +
                " " +
                data.tlc_create,
              subtitle: { deskripsi: data.adendum_nm },
              create_dt: data.create_dt,
              timeline: JSON.parse(data.status_app),
              subdesc: [
                [
                  {
                    label: "Create Date",
                    value: this.moment(data.create_dt,this.getStandartFormatDate).format(this.getDefaultDateFormat),
                  },
                ],
                [
                  {
                    label: "Value",
                    value: this.formatCurrency(
                      data.currency,
                      data.value_adendum
                    ),
                  },
                ],
              ],
              status: data.status,
              id: data.id_manifest,
              used_for: data.used_for,
              mata_uang: data.currency,
              transaction: data.jenis_transaksi,
              unread: data.unread == "1" ? true : false,
              closeStatus: data.close_sts=="1" ? "Close" : "",
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1
                  ? "Canceled"
                  : null
                : null,
              canceled_Status: data.canceled_status
                ? data.canceled_status == "1"
                  ? "Canceled"
                  : null
                : null, 
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    infoToggle(item) {
      this.informasi = {
        estimated_value: item.estimated_value,
        sisa_saldo: item.sisa_saldo,
        mata_uang: item.mata_uang,
      };
      this.modalInfo = !this.modalInfo;
    },
  },
};
</script>

<style lang="less">
</style>